import React, { FC } from 'react'
import { LineStyle, PropertyStyle } from './LineStyle'

export interface LineProps {
  property: string
  value: string
}

const Line: FC<LineProps> = ({ property, value }) => {
  return (
    <LineStyle>
      <div className="lineHeader">{property}</div>
      <PropertyStyle>
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </PropertyStyle>
    </LineStyle>
  )
}

export default Line
